// extracted by mini-css-extract-plugin
export default {"infoContainer":"Information_infoContainer__oLPX-","infoTitle":"Information_infoTitle__2pmzx","infoContent":"Information_infoContent__ZLX1Y"};